import React from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDanhSachThanhLy,
  updateDataSearch,
} from "../../actions/DanhSachThanhLy";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";

export const SearchBarDesktop = ({}) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchDanhSachThanhLy); //dataSearchTaiSan dinh nghia o rootreducer

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    // console.log(dataSearch);
    dispatch(getListDanhSachThanhLy(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListDanhSachThanhLy(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var tuNgay = currentDate();
  if (dataSearch.tuNgay === "01/01/2001") tuNgay = "";
  else tuNgay = dataSearch.tuNgay;
  var denNgay = currentDate();
  if (dataSearch.denNgay === "01/01/4000") denNgay = "";
  else denNgay = dataSearch.denNgay;
  denNgay = convertDate(denNgay);
  tuNgay = convertDate(tuNgay);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Tìm kiếm</label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Tên, SĐT, CCCD khách hàng"
            value={dataSearch.customerName}
            onChange={updateTextValue("customerName")}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Mã tài sản</label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Mã tài sản"
            value={dataSearch.taisanCode}
            onChange={updateTextValue("taisanCode")}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Mã hợp đồng</label>
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Mã hợp đồng"
            value={dataSearch.hopdongCode}
            onChange={updateTextValue("hopdongCode")}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={tuNgay}
            onChange={onChangeDate("tuNgay")}
            placeholder="Từ ngày"
            name="tuNgay"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={denNgay}
            onChange={onChangeDate("denNgay")}
            placeholder="Đến ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new btn-seach-ds"
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
